import { Page } from '@/core/architecture'

import { ConsoleItemDetailTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ConsoleItemDetail Page
 * Implemented as a practical sample.
 */
export const ConsoleItemDetail: Page = () => {
  const { state, actions } = useViewModel()

  return <ConsoleItemDetailTemplate state={state} {...actions} />
}
